import * as React from 'react';
import styled, { keyframes }  from 'styled-components';
import { useRecoilState, useRecoilValue } from 'recoil';//取得のみ
import { configJsonState } from '../../states/configJsonState';
import { nftJsonNoneMetaState } from '../../states/nftJsonNoneMetaState';

type Props = {
    // imageUrl:string,
}
export const NFTRecievingImage: React.FC<Props> = (props) => {
  const [configStatus , setConfigStatus] = useRecoilState(configJsonState);
  const nftInfo = useRecoilValue(nftJsonNoneMetaState);

  // filter: blur(2px);
  const RecievingImage = styled.img`
    display: unset;
    top: 80%;
    left: 50%;
    bottom: 0%;
    border-radius: 10px;
    filter: ${configStatus.nftReceivingImage.isBlurred ? 'blur(2px)' : 'none'};
    margin-top: 40px;
    z-index:100;
    
    @media (max-width: 2560px) {
      width: 40%;
      height: 40%;
    }
    @media (max-width: 768px) {
      width: 65%;
      height: 65%;
    }
  `;
  return (
    <div id="nftloadercolumn">
      <RecievingImage 
        id="nftimage" 
        // src={`${topImageStatus}`} 
        src={`${configStatus.nftReceivingImage.url?configStatus.nftReceivingImage.url:nftInfo.image}`} 
        alt=''
      />
    </div>
  );
}; 